module.exports = __webpack_public_path__ + "static/media/setur_pontuation_icon.01066707.svg";